import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class DashboardMessagesService extends RestfulService<Models.DashboardMessage> {

  constructor(public restService: RestService) {
    super(Models.DashboardMessage);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('dashboard-messages');
  }

}

